export default "__VITE_ASSET__CWvu1Lxa__"